var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#bfebff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back_round"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 301,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.88,257.62l163,133.65a20,20,0,0,0,32.68-15.46V108.51a20,20,0,0,0-32.68-15.46l-163,133.64A20,20,0,0,0,103.88,257.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.47,335.27c0,91-90.81,165.09-204,167.62-1.07,0,20.24-8.15,40.81-24.18,2.84-2.22,14.2-11.19,21.5-19.35,18.71-20.91,40.37-69.59,16.26-107.47-16-25.11-47.55-38.35-80.67-36V167.64C411.76,170,504.47,244.15,504.47,335.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRound);
export default __webpack_public_path__ + "static/media/back_round.837e99b7e5e0c659a01ae0345b64fa97.svg";
export { ForwardRef as ReactComponent };